import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { verify_user } from '../handlers/common/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);

const verifySession = async (token) => {
    try {
       
        if (token) {
             setToken(token);
             console.log('Session verified successfully', token);
            return true;
        }
        
        return false;
    } catch (error) {
         setLoading(false);
        return false;
    }
};
    const logout = () => {
        setToken(null);
        localStorage.removeItem('erpAuth');
    };

    return (
        <AuthContext.Provider value={{ token, loading, verifySession, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);